/*
 * Account routing — CANONICAL RULE.
 *
 *   "garage owner" = has an OWNERSHIP relationship to a garage (/user/garages),
 *   NOT the `user_type === 'garage_owner'` flag. (Verified in production: the DMS TUNED
 *   owner has user_type unset yet clearly owns a garage.)
 *
 * AUTHORITATIVE routing lives in the dashboard loaders (loadDriver / loadGarage): each
 * fetches /user/garages and redirects to the correct OS. So even if a nav link points to
 * the "wrong" dashboard, the destination self-corrects. Nav/post-login links use the
 * best-effort sync helper below (they cannot fetch on every render); the gate is the net.
 *
 * CUTOVER AUDIT — repoint every routing/gating site off sole `user_type` reliance:
 *   - App.js post-login redirect (App.js:~180)
 *   - AuthCallback (recovery / oauth / legacy-session branches)
 *   - SharedNav + HomeV4 account CTA
 *   - CheckoutPage / CheckoutSuccessPage success redirect
 *   - any professional/account redirect
 * Prefer resolveAccountHome(user) here + rely on the loader gates as the authoritative net.
 */

/** Best-effort account home from the user object alone (sync; no fetch).
 * driver / normal user -> /dashboard   ·   garage_owner-typed -> /my-garage
 * The dashboard loaders make the FINAL, ownership-based decision. */
export function resolveAccountHome(user) {
  return user && user.user_type === 'garage_owner' ? '/my-garage' : '/dashboard';
}

// Back-compat alias.
export const getAccountHome = resolveAccountHome;
